import React, { Component } from 'react';
// import Relay from 'react-relay/classic';

class ImageCorousel extends Component {
  static styles = {};

  render() {
    const styles = ImageCorousel.styles;

    return <div className="ImageCorouselContainer">Corousel images...</div>;
  }
}

export default ImageCorousel;
